export enum ErrorsTypes {
    Default = 'default',
    Notification = 'notification'
}
